import {createApp, ref} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import useVuelidate from '@vuelidate/core';
import {helpers, required} from '@vuelidate/validators';
import {vrm} from '../modules/regitValidators';
import sendAnalyticsEvent from '../modules/sendAnalyticsEvent';

const app = createApp({
    setup(props) {
        const state = {
            vrm: ref(''),
        };
        const rules = {
            vrm: {
                required: helpers.withMessage('Please enter your reg plate', required),
                vrm: helpers.withMessage('Please enter a valid reg', vrm),
            },
        };

        const v = useVuelidate(rules, state);
        async function submitForm(e: Event) {
            e.preventDefault();
            e.stopPropagation();

            const validationPassed = await v.value.$validate();
            if (validationPassed) {
                sendAnalyticsEvent('Conversion Tracking', 'Car Check', 'Submit VRM');
                (document.getElementById('car-check__form') as HTMLFormElement).submit();
            }
        }

        return {
            vrm: state.vrm,
            v$: v,
            submitForm,
        };
    },
    mounted() {
        sendAnalyticsEvent('Conversion Tracking', 'Car Check', 'Page View');
    },
});

connectVue(app);
configureGlobalComponents(app);
app.mount('#app');
